import { FC } from "react";

import { DashboardIconButton } from "@/dashboard-design-system/DashboardButton";
import { TableCellContainer } from "@/dashboard-design-system/DashboardTableCell/TableCellContainer";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Mail } from "@/icons/outlined";

export interface TableEmailCellProps {
  value: string;
  sendEmailLabel: string;
  onSendEmail: (email: string) => void;
}

const SEND_EMAIL_BUTTON = "[data-test='table-cell-send-email-button']";

export const TableEmailCell: FC<TableEmailCellProps> = ({ value, sendEmailLabel, onSendEmail }) => (
  <TableCellContainer
    layout="inline"
    data-test="table-email-cell"
    sx={{
      [`&:hover ${SEND_EMAIL_BUTTON}, &:focus-within ${SEND_EMAIL_BUTTON}`]: { opacity: 1 },
      "@media (hover: none)": { [`& ${SEND_EMAIL_BUTTON}`]: { opacity: 1 } },
    }}
  >
    <DashboardTypography variant="body2" vibe="text-neutral-moderate" noWrap sx={{ minWidth: 0 }}>
      {value}
    </DashboardTypography>
    <DashboardIconButton
      size="extraSmall"
      vibe="neutral"
      aria-label={sendEmailLabel}
      data-test="table-cell-send-email-button"
      onClick={(event) => {
        event.stopPropagation();
        onSendEmail(value);
      }}
      sx={{ opacity: 0 }}
    >
      <Mail />
    </DashboardIconButton>
  </TableCellContainer>
);
